// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-advanced-js": () => import("./../src/templates/advanced.js" /* webpackChunkName: "component---src-templates-advanced-js" */)
}

